import { ChevronLeftIcon, ChevronRightIcon, Flex, IconButton } from "@minervaproject/fds";
import { Dispatch, SetStateAction } from "react";

import { useCapability } from "hooks/capabilities";
import { useAppDispatch, useAppSelector } from "hooks/redux_hooks";
import { setResourcePage } from "shared/reducers/classroom";
import { CapabilityType, ResourceType } from "shared/types";
import { localSelectors } from "store";

function Pages({
  resource,
  numberOfPages,
  currentPage,
  setCurrentPage,
}: {
  resource: ResourceType;
  numberOfPages: number;
  currentPage: number;
  setCurrentPage: Dispatch<SetStateAction<number>>;
}) {
  const dispatch = useAppDispatch();
  const currentUserId = useAppSelector(localSelectors.selectCurrentUserId());
  const canControlClassroom = useCapability(CapabilityType.CAN_CONTROL_CLASSROOM);

  const handleChangePage = (offset: number) => () => {
    const newPage = currentPage + offset;
    if (newPage >= 1 && newPage <= numberOfPages) {
      setCurrentPage(newPage);
      if (resource.owner_id === currentUserId && canControlClassroom) {
        dispatch(
          setResourcePage({
            resourceId: resource.id,
            pageNumber: newPage,
          }),
        );
      }
    }
  };

  return (
    <Flex>
      <IconButton onClick={handleChangePage(-1)}>
        <ChevronLeftIcon width={16} height={16} color="var(--black-tint-70)" />
      </IconButton>
      <div>
        {currentPage}/{numberOfPages}
      </div>
      <IconButton onClick={handleChangePage(1)}>
        <ChevronRightIcon width={16} height={16} color="var(--black-tint-70)" />
      </IconButton>
    </Flex>
  );
}

export { Pages };
